import { useState } from "react";
import { Card, CardContent, CardHeader } from "components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "components/ui/tabs";
import FlowImport from "pages/Admin/FlowImport";
import FlowExport from "pages/Admin/FlowExport";

type TabValue = "import" | "export";

const FlowData: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabValue>("import");

  return (
    <Card disableAnimation maxWidth="none">
      <Tabs value={activeTab} onValueChange={(v) => setActiveTab(v as TabValue)} className="w-full">
        <CardHeader>
          <TabsList className="bg-transparent justify-start px-2">
            <TabsTrigger value="import" className="px-2">
              Import
            </TabsTrigger>
            <TabsTrigger value="export" className="px-2">
              Export
            </TabsTrigger>
          </TabsList>
        </CardHeader>
      </Tabs>

      <CardContent variant="form">
        <div className={activeTab !== "import" ? "hidden" : undefined}>
          <FlowImport hideExportButton />
        </div>
        <div className={activeTab !== "export" ? "hidden" : undefined}>
          <FlowExport />
        </div>
      </CardContent>
    </Card>
  );
};

export default FlowData;
